import type { Dispatch } from 'redux';
import { setIntroOpen } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/onboarding';
import {
	setActiveCard,
	setOnBoardingShown,
	type SetActiveCardAction,
	type SetIntroOpenAction,
	type SetOnBoardingShownAction,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/onboarding/actions';
import type { DispatchProps } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	dispatch: Dispatch<SetOnBoardingShownAction | SetActiveCardAction | SetIntroOpenAction>,
): DispatchProps => ({
	setOnBoardingShown: (shown: boolean) => {
		dispatch(setOnBoardingShown(shown));
	},
	setActiveCard: (activeCard: string) => {
		dispatch(setActiveCard(activeCard));
	},
	setIsIntroOpen: (isOpen: boolean) => {
		dispatch(setIntroOpen(isOpen));
	},
});
